export function formatNumberDisplay(value, { decimals = 0, unit } = {}) {
    if (value === null || value === undefined || value === "") return "-";
    const num = typeof value === "number" ? value : Number(value);
    if (Number.isNaN(num)) return "-";
    const nf = new Intl.NumberFormat("fr-FR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: decimals,
    });
    const base = nf.format(num);
    return unit ? `${base}\u00A0${unit}` : base;
}